import React from "react";

const WomenOfTheWorld = () => (
  <>
    {/* Hero Section */}
    <section
      className="relative text-white min-h-[80vh] flex items-center justify-center overflow-hidden"
      style={{
        background:
          "linear-gradient(90deg,rgba(230, 21, 170, 1) 0%, rgba(242, 29, 128, 1) 100%)",
      }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1616692474781-9ef0114c15b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
        }}
      ></div>

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight font-[Aeonik] leading-tight">
          Women of the World, Inc.
        </h1>
      </div>
    </section>

    {/* Content Section */}
    <div className="max-w-5xl mx-auto py-16 px-6 text-gray-800">
      <h2 className="text-3xl font-extrabold mb-6 text-main-pink">
        The Parent Company Behind Pink Help
      </h2>

      <p className="text-base leading-relaxed mb-4">
        <strong>Women of the World, Inc.</strong> is a global organization
        committed to building tools, platforms, and ecosystems that empower
        women in every country. It serves as the parent entity of{" "}
        <em>Pink Help</em> and oversees operations, partnerships, and governance
        of 250+ global women’s initiatives.
      </p>

      <p className="text-base leading-relaxed mb-4">
        The organization works across key sectors including:
      </p>

      <ul className="list-disc list-inside text-base text-gray-700 mb-6 space-y-1">
        <li>Economic empowerment</li>
        <li>Legal navigation</li>
        <li>Educational access</li>
        <li>Safe housing</li>
        <li>Community building</li>
        <li>Leadership and digital equity</li>
      </ul>

      <p className="text-base leading-relaxed">
        Rooted in the belief that every woman, everywhere, deserves support,{" "}
        <strong>Women of the World, Inc.</strong>
        powers platforms like <em>Pink Help</em> to serve women in the most
        practical and direct ways — by connecting them to real solutions.
      </p>
    </div>
  </>
);

export default WomenOfTheWorld;
